import {
  PreloadAllModules,
  Route,
  provideRouter,
  withHashLocation,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
} from '@angular/router';

const routes: Route[] = [
  {
    path: 'entry',
    loadComponent: () => import('./entry.component').then((m) => m.EntryComponent),
  },
  {
    path: 'template',
    loadComponent: () => import('./template.component').then((m) => m.TemplateComponent),
  },
  {
    path: 'health-check',
    loadComponent: () => import('./health-check.component').then((m) => m.HealthCheckComponent),
  },
  {
    path: '**',
    redirectTo: 'entry',
  },
];

export const appRouting = [
  provideRouter(
    routes,
    withHashLocation(),
    withPreloading(PreloadAllModules),
    withInMemoryScrolling({
      scrollPositionRestoration: 'enabled',
    }),
    withRouterConfig({
      //paramsInheritanceStrategy: 'always',
      //onSameUrlNavigation: 'reload',
    })
  ),
];
